import { createApp } from '@kano/calculator';
import { initPublicMessages } from '@kano/i18n';

(async () => {
  await initPublicMessages();
  const { app } = createApp();

  app.$mount('#calculator-app');
})();
